<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">
            Qualificação
            <strong>econômico-financeira</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-show="showBox">
      <v-flex infoDados>
        <v-card class="px-0">
          <v-layout row wrap>

            <v-flex xs12 pt-4>
              <div class="tituloBox border-top">
                <div class="bg-red barraTitulo"></div>
                <h1 class="text-default font-size-14">
                  <strong>{{$t('label.concordataEFalencia')}}</strong>
                </h1>
              </div>
            </v-flex>


            <v-flex xs12 pt-4>
              <v-data-table
                :headers="localheadersConcordataEFalencia"
                :items="[concordataFalencia]"
                :hide-actions="true"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left"><span v-html="retornaIfCadastrado(props.item.numDocumento)"></span></td>
                  <td class="text-xs-center"><span v-show="!props.item.dtEmissao" v-html="retornaIfCadastrado(props.item.dtEmissao)"></span>{{props.item.dtEmissao | dataFormatada}}</td>
                  <td class="text-xs-center" v-bind:class="{'dataVencida':verificaDataVencida(props.item.dtVencimento)}"><span v-show="!props.item.dtVencimento" v-html="retornaIfCadastrado(props.item.dtVencimento)"></span>{{props.item.dtVencimento | dataFormatada}}</td>
                  <td class="text-xs-left"><span v-show="!props.item.situacaoDoc" v-html="retornaIfCadastrado(props.item.situacaoDoc)"></span>{{retornaEnumDescricao("situacaoDoc",props.item.situacaoDoc)}}</td>
                  <td class="text-xs-left"><span v-html="retornaIfCadastrado(props.item.codControle)"></span></td>
                  <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" class="text-xs-center naoImprimir">                   
                   <a v-if="props.item.numDocumentoSEI && props.item.numDocumentoSEI !== null && props.item.numDocumentoSEI.length > 0" v-bind:href="props.item.arquivoUpload" target="_blank"><v-icon color="blue">attach_file</v-icon></a>
                    <v-icon v-else color="grey" ti>attach_file</v-icon></td> 
                </template>
              </v-data-table>
            </v-flex>

          <div v-if="model.tipFornecedor == 'J'">
            <v-flex xs12 pt-4>
              <div class="tituloBox border-top">
                <div class="bg-red barraTitulo"></div>
                <h1 class="text-default font-size-14">
                  <strong>{{$t('label.balanco')}}</strong>
                </h1>
              </div>
            </v-flex>
            <v-flex xs12 pt-4>
              <v-data-table
                :headers="localHeadersBalanco"
                :items="[balancoFinanceiro]"
                :hide-actions="true"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left"><span v-html="retornaIfCadastrado(props.item.numLivroDiario)"></span></td>
                  <td class="text-xs-center">
                    <span v-show="!props.item.dtBalanco" v-html="retornaIfCadastrado(props.item.dtBalanco)"></span>
                    {{props.item.dtBalanco | dataFormatada}}
                  </td>
                  <td class="text-xs-center" v-bind:class="{'dataVencida':verificaDataVencida(props.item.dtValidadeBalanco)}">
                    <span v-show="!props.item.dtValidadeBalanco" v-html="retornaIfCadastrado(props.item.dtValidadeBalanco)"></span>
                    {{props.item.dtValidadeBalanco | dataFormatada}}
                  </td>
                  <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" class="text-xs-center naoImprimir">
                    <a v-if="props.item.numDocumentoSEI && props.item.numDocumentoSEI !== null &&
                      props.item.numDocumentoSEI.length > 0" v-bind:href="props.item.arquivoUpload" target="_blank">
                      <v-icon color="blue">attach_file</v-icon>
                    </a>
                    <v-icon v-else color="grey">attach_file</v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          <v-layout row wrap>
            <v-flex xs12 sm6 pa-0>
              <v-card>
                <v-card-title>
                  <h4>
                    <strong>{{$t('label.ativo')}}</strong>
                  </h4>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.ativoCirculante')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong
                        class="text-info"
                      >{{balancoFinanceiro.ativoCirculante | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <strong>{{$t('label.ativoNaoCirculante')}}</strong>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong>{{ativoNaoCirculante | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.realizavelALongoPrazo')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.realizavelLP | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.investimento')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.investimento | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.imobilizado')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.imobilizado | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.intangivel')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.intangivel | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile class="bgClaro">
                    <v-list-tile-content>
                      <strong class="text-primary">{{$t('label.ativoTotal')}}</strong>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-primary">{{ativoTotal | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>

            <v-flex xs12 sm6 pa-0>
              <v-card>
                <v-card-title>
                  <h4>
                    <strong>{{$t('label.passivo')}}</strong>
                  </h4>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.passivoCirculante')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong
                        class="text-info"
                      >{{balancoFinanceiro.passivoCirculante | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <strong>{{$t('label.passivoNaoCirculante')}}</strong>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong>{{passivoNaoCirculante | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.exigivelALongoPrazo')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.exigivelLP | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.resultadoDeExerciciosFuturos')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong
                        class="text-info"
                      >{{balancoFinanceiro.resultExerciciosFut | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.patrimonioLiquido')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong
                        class="text-info"
                      >{{balancoFinanceiro.patrimonioLiquido | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content></v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info"></strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile class="bgClaro">
                    <v-list-tile-content>
                      <strong class="text-primary">{{$t('label.passivoTotal')}}</strong>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-primary">{{passivoTotal | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>

        <v-layout row wrap>
            <v-flex infoDados>
                <v-card-title>
                  <h4>
                    <strong>{{$t('label.receita')}}</strong>
                  </h4>
                </v-card-title>
                <v-divider></v-divider>

                <v-data-table
                  :headers="headersReceita"
                  :items="[balancoFinanceiro]"
                  :hide-actions="true"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{props.item.capitalSocial | formatarMoeda}}</td>
                    <td class="text-xs-left">{{props.item.receitaOpeLiquido | formatarMoeda}}</td>
                    <td class="text-xs-left">{{props.item.receitaOpeBruto | formatarMoeda}}</td>
                  </template>
                </v-data-table>
            </v-flex>

       </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <h4 class="pb-4">
                <strong>{{$t('label.outrosIndices')}}</strong>
              </h4>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="outrosIndices">
            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.mediaFinanceira')"
                :value="mediaFinanceira | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.liquidezCorrente')"
                :value="liquidezCorrente | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.liquidezGeral')"
                :value="liquidezGeral | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.solvenciaGeral')"
                :value="solvenciaGeral | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.produtividade')"
                :value="produtividade | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.endividamento')"
                :value="endividamento | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.imobilizacaoCapitalProprio')"
                :value="imobilizacaoCapitalProprio | formatPercentage"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.capitalizacao')"
                :value="capitalizacao | formatPercentage"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

          </v-layout>
         </div>
         <div v-if="model.tipFornecedor == 'J' && obrigarBalanco2() != 'semBalanco2'">
            <v-flex xs12 pt-4>
              <div class="tituloBox border-top">
                <div class="bg-red barraTitulo"></div>
                <h1 class="text-default font-size-14">
                  <strong>{{$t('label.balanco2')}}</strong>
                </h1>
              </div>
            </v-flex>
            <v-flex xs12 pt-4>
              <v-data-table
                :headers="localHeadersBalanco"
                :items="[balancoFinanceiro]"
                :hide-actions="true"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left"><span v-html="retornaIfCadastrado(props.item.numLivroDiario02)"></span></td>
                  <td class="text-xs-center">
                    <span v-show="!props.item.dtBalanco02" v-html="retornaIfCadastrado(props.item.dtBalanco02)"></span>
                    {{props.item.dtBalanco02 | dataFormatada}}
                  </td>
                  <td class="text-xs-center" v-bind:class="{'dataVencida':verificaDataVencida(props.item.dtValidadeBalanco02)}">
                    <span v-show="!props.item.dtValidadeBalanco" v-html="retornaIfCadastrado(props.item.dtValidadeBalanco02)"></span>
                    {{props.item.dtValidadeBalanco02 | dataFormatada}}
                  </td>
                  <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" class="text-xs-center naoImprimir">
                     <a v-if="props.item.numDocumentoSEI02 && props.item.numDocumentoSEI02 !== null &&
                      props.item.numDocumentoSEI02.length > 0" v-bind:href="props.item.arquivoUpload02" target="_blank">
                      <v-icon color="blue">attach_file</v-icon>
                    </a>
                    <v-icon v-else color="grey" ti>attach_file</v-icon>
                  </td> 
                </template>
              </v-data-table>
            </v-flex>
          <v-layout row wrap>
            <v-flex xs12 sm6 pa-0>
              <v-card>
                <v-card-title>
                  <h4>
                    <strong>{{$t('label.ativo')}}</strong>
                  </h4>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.ativoCirculante')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong
                        class="text-info"
                      >{{balancoFinanceiro.ativoCirculante02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <strong>{{$t('label.ativoNaoCirculante')}}</strong>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong>{{ativoNaoCirculante02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.realizavelALongoPrazo')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.realizavelLP02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.investimento')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.investimento02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.imobilizado')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.imobilizado02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.intangivel')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.intangivel02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile class="bgClaro">
                    <v-list-tile-content>
                      <strong class="text-primary">{{$t('label.ativoTotal')}}</strong>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-primary">{{ativoTotal02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>

            <v-flex xs12 sm6 pa-0>
              <v-card>
                <v-card-title>
                  <h4>
                    <strong>{{$t('label.passivo')}}</strong>
                  </h4>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.passivoCirculante')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong
                        class="text-info"
                      >{{balancoFinanceiro.passivoCirculante02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <strong>{{$t('label.passivoNaoCirculante')}}</strong>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong>{{passivoNaoCirculante02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.exigivelALongoPrazo')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info">{{balancoFinanceiro.exigivelLP02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.resultadoDeExerciciosFuturos')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong
                        class="text-info"
                      >{{balancoFinanceiro.resultExerciciosFut02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>{{$t('label.patrimonioLiquido')}}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong
                        class="text-info"
                      >{{balancoFinanceiro.patrimonioLiquido02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content></v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-info"></strong>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile class="bgClaro">
                    <v-list-tile-content>
                      <strong class="text-primary">{{$t('label.passivoTotal')}}</strong>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <strong class="text-primary">{{passivoTotal02 | formatarMoeda}}</strong>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>

        <v-layout row wrap>
            <v-flex infoDados>
                <v-card-title>
                  <h4>
                    <strong>{{$t('label.receita')}}</strong>
                  </h4>
                </v-card-title>
                <v-divider></v-divider>

                <v-data-table
                  :headers="headersReceita"
                  :items="[balancoFinanceiro]"
                  :hide-actions="true"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{props.item.capitalSocial02 | formatarMoeda}}</td>
                    <td class="text-xs-left">{{props.item.receitaOpeLiquido02 | formatarMoeda}}</td>
                    <td class="text-xs-left">{{props.item.receitaOpeBruto02 | formatarMoeda}}</td>
                  </template>
                </v-data-table>
            </v-flex>

       </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <h4 class="pb-4">
                <strong>{{$t('label.outrosIndices')}}</strong>
              </h4>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="outrosIndices">
            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.mediaFinanceira')"
                :value="mediaFinanceira02 | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.liquidezCorrente')"
                :value="liquidezCorrente02 | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.liquidezGeral')"
                :value="liquidezGeral02 | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.solvenciaGeral')"
                :value="solvenciaGeral02 | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.produtividade')"
                :value="produtividade02 | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.endividamento')"
                :value="endividamento02 | formatarMoeda"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.imobilizacaoCapitalProprio')"
                :value="imobilizacaoCapitalProprio02 | formatPercentage"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                :label="$t('label.capitalizacao')"
                :value="capitalizacao02 | formatPercentage"
                required
                disabled
                validate-on-blur
              ></v-text-field>
            </v-flex>

          </v-layout>
         </div>
         </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import dominioService from "../../../services/dominioService";
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import moment from 'moment';
import { mounted } from "vue-popperjs";
export default {
  name: "extrato-qualificacao-economica",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio: Object,
    enums: Object
  },
  mounted() {
    this.localHeadersBalanco = this.headersBalanco; // Inicializa com os headers do mixin
    this.localheadersConcordataEFalencia = this.headersConcordataEFalencia;
    if (this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()) {
      this.localHeadersBalanco.push({
        text: this.$t("label.anexo"),
        align: "center",
        sortable: false,
        class: "naoImprimir",
      });

      this.headersConcordataEFalencia.push({
        text: this.$t("label.anexo"),
        align: "center",
        sortable: false,
        class: "naoImprimir",
      });
    }
  },
  created() /*Metodo de start do componente*/{



    dominioService.getPontuacaoIndices().then(response => { /*resposta do servico*/
      this.pontuacaoIndices = response.data; /*dados de retorno*/

      this.calcAtivos();
      this.calcPassivos();
      this.calcSolvencia();
      this.calcLiqCorrente();
      this.calcLiqGeral();
      this.calcProdutividade();
      this.calcEndividamento();
      this.calcICP();
      this.calcCapitalizacao();
      this.calcMediaFinanceira();
    });
  },

  computed: {//Campos computados
    balancoFinanceiro() {
      //retornar os dados do balanco
      if (!this.model.balancoFinanceiro) return {};
      return this.model.balancoFinanceiro;
    },
     concordataFalencia() {
       //retorna os dados de concordata
      if (!this.model.concordataFalencia) return {};
      return this.model.concordataFalencia;
    }
  },

  data() {//Declaracao de variaveis
    return {
      localheadersConcordataEFalencia: [],
      localHeadersBalanco: [],
      showBox: true,
      ativoNaoCirculante: 0,
      ativoTotal: 0,
      passivoNaoCirculante: 0,
      passivoTotal: 0,
      solvenciaGeral: 0,
      liquidezCorrente: 0,
      liquidezGeral: 0,
      produtividade: 0,
      endividamento: 0,
      capitalizacao: 0,
      imobilizacaoCapitalProprio: 0,
      mediaFinanceira: 0,
      pontuacaoIndices: [],
      totaisContas: {
        ativoTotal: 0,
        passivoTotal: 0
      },
      ativoNaoCirculante02: 0,
      ativoTotal02: 0,
      passivoNaoCirculante02: 0,
      passivoTotal02: 0,
      solvenciaGeral02: 0,
      liquidezCorrente02: 0,
      liquidezGeral02: 0,
      produtividade02: 0,
      endividamento02: 0,
      capitalizacao02: 0,
      imobilizacaoCapitalProprio02: 0,
      mediaFinanceira02: 0,
      pontuacaoIndices02: [],
      totaisContas02: {
        ativoTotal02: 0,
        passivoTotal02: 0
      }
    };
  },

  methods: {//Declaracao de todos os metodos
    openBox() {
      //mostrar ou ocultar o box
      this.showBox = !this.showBox;
    },
    obrigarBalanco2() {
    return fornecedorService.getRegularidadeFiscalTipoDoc(this.model.numCgcFornecedor, 1)
        .then(response => {
            if (!response.data || response.data.length === 0 || !response.data[0].dtAberturaEmpresa) {
                return 'semBalanco2'; // Se não houver data de abertura, retorna sem Balanço 2
            }

            let dataAbertura = moment(response.data[0].dtAberturaEmpresa);

            // *** Para testes, altere a data atual manualmente ***
            let dataAtual = moment(); // Defina a data desejada para testar

            // Ajusta a data de abertura caso esteja entre 15/12 e 31/12
            if (dataAbertura.isBetween(`${dataAbertura.year()}-12-15`, `${dataAbertura.year()}-12-31`, null, '[]')) {
                dataAbertura.add(1, 'year').startOf('year');
            }

            let dataDoisAnos = dataAbertura.clone().add(2, 'years');

            // Caso a empresa tenha menos de 2 anos, nunca obriga o Balanço 2
            if (dataAtual.isBefore(dataDoisAnos)) {
                return 'semBalanco2';
            }

            // Determina o último dia útil de junho do ano corrente
            let ultimoDiaUtilJunho = moment(`${dataAtual.year()}-06-30`);
            if (ultimoDiaUtilJunho.day() === 6) {
                ultimoDiaUtilJunho.subtract(1, 'days'); // Se for sábado, volta para sexta
            } else if (ultimoDiaUtilJunho.day() === 0) {
                ultimoDiaUtilJunho.subtract(2, 'days'); // Se for domingo, volta para sexta
            }

            // Se completou 2 anos no primeiro semestre e ainda não passou do último dia útil de junho
            if (
                dataDoisAnos.year() === dataAtual.year() &&
                dataDoisAnos.month() < 6 && // Completou 2 anos entre janeiro e junho
                dataAtual.isBefore(ultimoDiaUtilJunho)
            ) {
                return 'comBalanco2'; // Pode enviar sem Balanço 2 até junho
            }

            return 'obrigaBalanco2'; // Se já passou do prazo, exige normalmente
        })
        .catch(error => {
            console.error("Erro ao obter dados fiscais:", error);
            return 'semBalanco2';
        });
},


    calcAtivos() {
      //calcular os tivos
      let _ativoNaoCirculante =
        Number(this.balancoFinanceiro.realizavelLP) +
        Number(this.balancoFinanceiro.imobilizado) +
        Number(this.balancoFinanceiro.investimento) +
        Number(this.balancoFinanceiro.intangivel);
      this.ativoNaoCirculante = _ativoNaoCirculante ? _ativoNaoCirculante : 0;

      let _ativoTotal =
        Number(this.ativoNaoCirculante) +
        Number(this.balancoFinanceiro.ativoCirculante);
      this.ativoTotal = _ativoTotal ? _ativoTotal : 0;
      this.totaisContas.ativoTotal = this.ativoTotal;

      //calcular os ativos 2
      let _ativoNaoCirculante02 =
        Number(this.balancoFinanceiro.realizavelLP02) +
        Number(this.balancoFinanceiro.imobilizado02) +
        Number(this.balancoFinanceiro.investimento02) +
        Number(this.balancoFinanceiro.intangivel02);
      this.ativoNaoCirculante02 = _ativoNaoCirculante02 ? _ativoNaoCirculante02 : 0;

      let _ativoTotal02 =
        Number(this.ativoNaoCirculante02) +
        Number(this.balancoFinanceiro.ativoCirculante02);
      this.ativoTotal02 = _ativoTotal02 ? _ativoTotal02 : 0;
      this.totaisContas02.ativoTotal02 = this.ativoTotal02;
    },
    calcPassivos() {
      //calcular os passivos
      let _passivoNaoCirculante =
        Number(this.balancoFinanceiro.exigivelLP) +
        Number(this.balancoFinanceiro.resultExerciciosFut);
      this.passivoNaoCirculante = _passivoNaoCirculante
        ? _passivoNaoCirculante
        : 0;

      let _passivoTotal =
        Number(this.passivoNaoCirculante) +
        Number(this.balancoFinanceiro.passivoCirculante) +
        Number(this.balancoFinanceiro.patrimonioLiquido);

      this.passivoTotal = _passivoTotal ? _passivoTotal : 0;
      this.totaisContas.passivoTotal = this.passivoTotal;


      //calcular os passivos 2
      let _passivoNaoCirculante02 =
        Number(this.balancoFinanceiro.exigivelLP02) +
        Number(this.balancoFinanceiro.resultExerciciosFut02);
      this.passivoNaoCirculante02 = _passivoNaoCirculante02
        ? _passivoNaoCirculante02
        : 0;

      let _passivoTotal02 =
        Number(this.passivoNaoCirculante02) +
        Number(this.balancoFinanceiro.passivoCirculante02) +
        Number(this.balancoFinanceiro.patrimonioLiquido02);

      this.passivoTotal02 = _passivoTotal02 ? _passivoTotal02 : 0;
      this.totaisContas02.passivoTotal02 = this.passivoTotal02;
    },

    calcSolvencia() {
      //calcular solvencia
      let cal1 =
        Number(this.balancoFinanceiro.ativoCirculante) +
        Number(this.ativoNaoCirculante);
      let cal2 =
        Number(this.balancoFinanceiro.passivoCirculante) +
        Number(this.balancoFinanceiro.exigivelLP);
      let resultado = cal1 && cal2 ? cal1 / cal2 : 0;
      this.solvenciaGeral = resultado ? resultado : 0;

      //calcular solvencia 2
      let cal01 =
        Number(this.balancoFinanceiro.ativoCirculante02) +
        Number(this.ativoNaoCirculante02);
      let cal02 =
        Number(this.balancoFinanceiro.passivoCirculante02) +
        Number(this.balancoFinanceiro.exigivelLP02);
      let resultado02 = cal01 && cal02 ? cal01 / cal02 : 0;
      this.solvenciaGeral02 = resultado02 ? resultado02 : 0;
    },
    calcLiqCorrente() {
      //calcular liquidacao corrente
      this.liquidezCorrente =
        Number(this.balancoFinanceiro.ativoCirculante) &&
        Number(this.balancoFinanceiro.passivoCirculante)
          ? Number(this.balancoFinanceiro.ativoCirculante) /
            Number(this.balancoFinanceiro.passivoCirculante)
          : 0;
      
      this.liquidezCorrente02 = this.balancoFinanceiro.passivoCirculante02 > 0 &&
      this.balancoFinanceiro.ativoCirculante02 !== null &&
      this.balancoFinanceiro.passivoCirculante02 !== null
        ? Number(this.balancoFinanceiro.ativoCirculante02) / Number(this.balancoFinanceiro.passivoCirculante02)
        : 0;
    },

    calcLiqGeral() {
      //calcular liquidacao geral
      let calc1 =
        Number(this.balancoFinanceiro.ativoCirculante) +
        Number(this.balancoFinanceiro.realizavelLP);
      let calc2 =
        Number(this.balancoFinanceiro.passivoCirculante) +
        Number(this.balancoFinanceiro.exigivelLP);

      this.liquidezGeral = calc1 && calc2 ? calc1 / calc2 : 0;


      //calcular liquidacao geral 2
      let calc01 =
        Number(this.balancoFinanceiro.ativoCirculante02) +
        Number(this.balancoFinanceiro.realizavelLP02);
      let calc02 =
        Number(this.balancoFinanceiro.passivoCirculante02) +
        Number(this.balancoFinanceiro.exigivelLP02);

      this.liquidezGeral02 = calc01 && calc02 ? calc01 / calc02 : 0;
    },

    calcProdutividade() {
      //calcular produtividade
      let calc1 =
        Number(this.ativoTotal) - Number(this.balancoFinanceiro.investimento);

      this.produtividade =
        calc1 && Number(this.balancoFinanceiro.receitaOpeLiquido)
          ? Number(this.balancoFinanceiro.receitaOpeLiquido) / calc1
          : 0;

      
          //calcular produtividade 2
      let calc01 =
        Number(this.ativoTotal02) - Number(this.balancoFinanceiro.investimento02);

      this.produtividade02 =
        calc01 && Number(this.balancoFinanceiro.receitaOpeLiquido02)
          ? Number(this.balancoFinanceiro.receitaOpeLiquido02) / calc01
          : 0;
    },

    calcEndividamento() {
      //calcular endividamento
      let calc1 =
        Number(this.balancoFinanceiro.passivoCirculante) +
        Number(this.balancoFinanceiro.exigivelLP);
      this.endividamento =
        calc1 && Number(this.ativoTotal) ? calc1 / Number(this.ativoTotal) : 0;

      //calcular endividamento 2
      let calc01 =
        Number(this.balancoFinanceiro.passivoCirculante02) +
        Number(this.balancoFinanceiro.exigivelLP02);
      this.endividamento02 =
        calc01 && Number(this.ativoTotal02) ? calc01 / Number(this.ativoTotal02) : 0;
    },

    calcCapitalizacao() {
      //calcular capitalizacao
      this.capitalizacao = Number(this.ativoTotal)
        ? (Number(this.balancoFinanceiro.patrimonioLiquido) /
            Number(this.ativoTotal)) *
          100
        : 0;

        //calcular capitalizacao 2
      this.capitalizacao02 = Number(this.ativoTotal02)
        ? (Number(this.balancoFinanceiro.patrimonioLiquido02) /
            Number(this.ativoTotal02)) *
          100
        : 0;
    },

    calcICP() {
      //calcular icp
      this.imobilizacaoCapitalProprio =
        Number(this.balancoFinanceiro.imobilizado) &&
        Number(this.balancoFinanceiro.patrimonioLiquido)
          ? (Number(this.balancoFinanceiro.imobilizado) /
              Number(this.balancoFinanceiro.patrimonioLiquido)) *
            100
          : 0;

      //calcular icp
      this.imobilizacaoCapitalProprio02 =
        Number(this.balancoFinanceiro.imobilizado02) &&
        Number(this.balancoFinanceiro.patrimonioLiquido02)
          ? (Number(this.balancoFinanceiro.imobilizado02) /
              Number(this.balancoFinanceiro.patrimonioLiquido02)) *
            100
          : 0;
    },
    getIndPont(codPontInd, valor) {
      //capturar indice de pontuacao
      let valores = this.pontuacaoIndices.find(
        pontuacao =>
          pontuacao.codPontInd === codPontInd &&
          valor >= pontuacao.limInf &&
          valor <= pontuacao.limSup
      );

      return valores ? valores.indPont : 0;
    },
    calcMediaFinanceira() {
      //calcular media financeira
      let ntProd = this.getIndPont(1, this.produtividade);
      let ntLG = this.getIndPont(2, this.liquidezGeral);
      let ntLC = this.getIndPont(3, this.liquidezCorrente);
      let ntCap = this.getIndPont(4, this.capitalizacao);
      let ntICP = this.getIndPont(5, this.imobilizacaoCapitalProprio);

      this.mediaFinanceira = (ntProd + ntLG + ntLC + ntCap + ntICP) / 5;

      //calcular media financeira 2
      let ntProd02 = this.getIndPont(1, this.produtividade02);
      let ntLG02 = this.getIndPont(2, this.liquidezGeral02);
      let ntLC02 = this.getIndPont(3, this.liquidezCorrente02);
      let ntCap02 = this.getIndPont(4, this.capitalizacao02);
      let ntICP02 = this.getIndPont(5, this.imobilizacaoCapitalProprio02);

      this.mediaFinanceira02 = (ntProd02 + ntLG02 + ntLC02 + ntCap02 + ntICP02) / 5;
    },
    formatarNumero(valor, percent) {
      //formatar moeda e percentual
      return (
        (!percent ? "R$ " : "") +
        valor.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) +
        (percent ? "%" : "")
      );
    },

    retornaEnumDescricao(_enum, valor) {
      //retornar descricao do enum
      if (!valor || !this.enums[_enum]) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.descricao : null;
    },
   baixarArquivo(arquivo) {
     //baixar o documento
     const numCgcFornecedor = this.$verificaPerfilCadastrador() ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "") : null;
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
    },
  }
};
</script>

<style scope>
.infoDados .v-card {
  padding: 15px;
}

.align-end {
    -moz-box-align: end;
    align-items: flex-end !important;
}

.infoDados .linhaInfo {
  display: block;
  padding: 5px 0;
}

.theme--light.v-table thead {
  background: none;
}

.v-list > div {
  border-bottom: dotted 1px #ddd;
}

.bgClaro {
  background-color: #f8f8f8;
}

.outrosIndices input {
  text-align: right !important;
  color: #349fbe !important;
  font-weight: bold;
}

.outrosIndices .v-label {
  color: #000 !important;
}
</style>


